import { LocaleDict } from '../locale-dict-type';

const locale: LocaleDict = {
  test: 'test',
  empty: 'No hay datos',
  basicLanguagaeLabel: '', // TODO: needs to be defined
  date: {
    formats: {
      tiny: 'DD/MM/YY',
      short: 'DD/MM/YYYY',
    },
  },
  common: {
    all: 'Todas',
    selectAll: 'Seleccionar todo',
    of: 'de',
    yes: 'sí',
    no: 'no',
    and: 'exactamente (todos)',
    or: 'contiene al menos',
  },
  list_circulation: {
    CHART_TRANSPORTATION_PLAN: 'Plan de transporte',
    CHART_DATE: 'Fecha',
    CHART_TRAIN: 'Tren',
    CHART_DEPARTURE: 'Salida',
    CHART_STATION: 'Estación',
    CHART_TIME: 'Hora',
    CHART_ARRIVAL: 'Llegada',
    CHART_PASSENGER_NUMBER: 'Número de pasajeros',
    CHART_WAGON_1: '1 a 8',
    CHART_WAGON_2: '9 a 16',
    CHART_PASSENGERS_1: '1 a 8',
    CHART_PASSENGERS_2: '9 a 16',
    CHART_LAST_SEND_TYPE: 'Tipo',
    CHART_LAST_SEND_SCHEDULE: 'Fecha y hora',
    CHART_LAST_SEND_DETAILS: 'Detalles',
    CHART_PRE_OP_COM: 'Comunicar en pre-operativo',
    CHART_OP_COM: 'Comunicar en operativo',
    CHART_POST_OP_COM: 'Comunicar en post-operativo',
    CHART_COM_CANCELLATION: 'Cancelación',
    CHART_PRE_OP_COM_OTHER: 'Otras informaciones pre-operativas',
    CHART_OP_COM_OTHER: 'Otras informaciones operativas',
    CHART_COM_DIVERSION: 'Desvío',
    CHART_COM_STATION_LIMITATION: 'Limitación del trayecto	',
    CHART_PLATFORM: 'Anuncio del andén',
    CHART_COM_DELAY: 'Retraso',
    CHART_COM_NORMAL: 'Tráfico normal',
    CHART_COM_NB_PASSENGERS: 'Número de asientos ocupados',
    CHART_COM_LAST_COM: 'Comunicaciones anteriores',
    CHART_COM_LAUNCH_COM: 'Enviar una nueva comunicación',
  },
  form: {
    FORM_USER_NAME: 'Apellido',
    FORM_USER_SURNAME: 'Nombre',
    FORM_USER_CIRCULATION_TYPE_CLASSIC: 'Otro (no usado)',
    FORM_USER_CIRCULATION_TYPE_SPEED: 'Alta velocidad',
    FORM_USER_PROFIL: 'Perfil',
    FORM_USER_CIRCULATION_TYPE: 'Tipo de trafico',
    FORM_USER_GROUP: 'Etiqueta',
    FORM_PROFILE_TYPE_ADMIN: 'Administrador',
    FORM_PROFILE_TYPE_TI_SUPERVISOR: 'Supervisor IV',
    FORM_CREATION_DATE: 'Fecha de creación :',
    FORM_RESET_PASSWORD: 'Reinicializar la contraseña',
    FORM_EXPIRED_PASSWORD: 'Restablecer la contraseña',
    FORGOT_PASSWORD_LINK: '¿Ha olvidado la contraseña?',
    FORM_CONNECT_LINK: 'Conectarse',
    RESET_PASSWORD_REQUEST: 'Solicitud de reinicialización de la contraseña',
    FORM_USERNAME: 'Nombre de usuario',
    FORM_EMAIL: 'Dirección e-mail',
    FORM_PASSWORD: 'Contraseña',
    FORM_CONFIRM_PASSWORD: 'Confirmar la contraseña',
    TEMPORARY_PASSWORD_EMAIL_SENT: 'Mandaremos a esta dirección un e-mail de confirmación.',
    RESET_PASSWORD_OK: 'La reinicialización de la contraseña se está realizando',
    FORM_CONNECT_ERROR: 'Usuario o contraseña incorrecto',
    FORM_FORGOT_PASSWORD_ERROR: 'Occurió un error',
    FORM_CONNECT_TITLE: 'Conexión',
    FORM_FORGOT_PASSWORD_TITLE: '¿Ha olvidado la contraseña?',
    FORM_USER_ALLREADY_EXIST: 'La dirección de correo electrónico ya existe.',
    FORM_USER_EMAIL_ALLREADY_EXIST: 'La dirección de correo electrónico ya existe.',
    FORM_USER_USERNAME_ALLREADY_EXIST: 'El nombre de usuario ya existe.',
    FORM_TYPOLOGY_ALLREADY_EXIST: 'La tipología ya existe.',
    FORM_PROFIL_ALLREADY_EXIST: 'El perfil ya existe.',
    FORM_SITUATION_ALLREADY_EXIST: 'La situación ya existe.',
    FORM_REASON_ALLREADY_EXIST: 'El motivo ya existe.',
    FORM_PRODUCT_CODE_ALLREADY_EXIST: 'El product_code ya existe.',
    FORM_UNKNOWN_ERROR: 'Occurió un error. Ha fallado la operación.',
    FORM_UPDATE_TEMP_PASSWORD: 'Contraseña recibida',
    FORM_EXPIRED_CURRENT_PASSWORD: 'Contraseña actual',
    FORM_UPDATE_NEW_PASSWORD: 'Nueva contraseña',
    FORM_UPDATE_CONFIRM_PASSWORD: 'Confirmar la nueva contraseña',
    FORM_WRONG_TEMPORARY_PWD: 'Contraseña temporal incorrecta',
    IMPACTED_CUSTOMERS_SELECTION_H3: 'Seleccione el tipo de viajeros',
    IMPACTED_DV_NUMBERS_H3: 'Introducir localizadores',
    DEPARTURE_STATIONS_IMPACTED_H3: 'Seleccionar la(s) estación(es) afectada(s)',
    ALL_CUSTOMERS: 'Todos los viajeros del tren',
    DESCENDING_CUSTOMERS: ' Viajeros que bajan en la estación',
    ASCENDING_CUSTOMERS: ' Viajeros que suben en la estación',
    ASCENDING_DESCENDING_CUSTOMERS: ' Viajeros que suben y bajan en la estación',
    ASCENDING_STATIONS_EXCLUSION_H3: 'Excluir estación(es) de subida (opcional)',
    CUSTOMER_SELECTION_IN_COACHES_H3: 'Seleccionar los viajeros presentes en los coches	',
    CHART_WAGON_1: '1 a 8	',
    CHART_WAGON_2: '9 a 16',
    ADDITIONNAL_CUSTOMER_INFO_H3: 'Indicar la información adicional',
    CHART_REASON: 'Motivo',
    CHART_SITUATION: 'Situación',
    NEW_TITLE: 'Elementos de contextualización',
    NEW_TITLE1: 'Asunto del correo',
    NEW_TITLE11: 'Asunto del correo : ',
    NEW_TITLE2: 'Cabecera del correo',
    NEW_TITLE22: 'Cabecera del correo : ',
    NEW_TITLE3: '¡Échale un ojo! Información sobre tu viaje del jj/mm/aaaa.',
    NEW_TITLE4: 'Algo ha cambiado. Y queremos que lo sepas.',
    NEW_TITLE5: '¡Échale un ojo! Información importante sobre tu viaje',
    NEW_TITLE6: 'Atento. Sabemos que esto te interesa.',
    NEW_TITLE7: '¡Échale un ojo! Información importante sobre tu viaje del jj/mm/aaaa.',
    NEW_TITLE8: 'Elegir la Situación',
    NEW_TITLE20: 'Sin plantilla de correo electrónico asociada.',
    NEW_TITLE21: 'Sin plantilla de WhatsApp asociada.',
    NEW_TITLE9: 'Otros',
    NEW_TITLE10: 'Bar cerrado',
    NEW_TITLE33: 'Reducción de composición UM > US',
    NEW_DEPARTURE_STATION_AND_SCHEDULE_H3: 'Completar la nueva estación y el nuevo horario asociado',
    NEW_SCHEDULE: 'Nuevo horario :',
    P_H_SUBSTITUTION_STATION: 'Estación de sustitución',
    P_H_TIME_FORMAT: 'HH:mm',
    INCIDENT_DETAILS_H4: 'Detalles sobre el incidente',
    COMPENSATION_MEASURES_AND_AFTERSALES_H4: 'Medidas de asistencia y de servicio postventa',
    SIGNATURE_H4: 'Firma',
    CUSTOMERS_INDEMNIFICATION_H3: 'Compensación viajeros',
    ASCENDING_CUSTOMERS_LIMITATION: 'Previsión de viajeros que suben en el tramo limitado',
    DESCENDING_CUSTOMERS_LIMITATION: 'Previsión de viajeros que bajan en el tramo limitado',
    SELECT_IMPACTED_SEGMENTS_LIMITATION_H3: 'Seleccionar el o los tramos afectados por la limitación de trayecto',
    DELAY_TYPE_H3: 'Seleccionar el tipo de retraso',
    ARRIVAL_DELAY_DESCENDING_CUSTOMERS: 'Retraso en la salida (viajeros que suben en la estación)',
    DEPARTURE_DELAY_ASCENDING_CUSTOMERS: 'Retraso en la llegada (viajeros que bajan en la estación)',
    IMPACTED_STATIONS_DIVERSION_H3: 'Seleccionar la(s) estación(es) afectada(s) por el desvío',
    SELECT_IMPACTED_STATION_DELAY: 'Seleccionar la(s) estación(es) afectada(s) por el retraso',
    SELECT_IMPACTED_STATION_H3: 'Seleccionar la(s) estación(es) afectada(s)',
    INFORMATION_COM_H4: 'Informaciones para comunicar',
    DEPARTURE_PLATFORM_H3: 'Completar el andén',
    'P-H-PLATFORM': 'Andén :',
    OTHER_INFORMATION_COM_H4: 'Otras informaciones',
    NEW_SCHEDULE_H3: 'Completar el retraso',
    NEW_SCHEDULE_H4: 'Otro :',
    SELECTED_SEGMENT_H3: 'Informaciones sobre el tramo',
    SELECTED_STATION_H3: '	Informaciones sobre la estación ',
    ALL_STATIONS_CONCERNED: 'Información sobre todas las estaciones',
    WARNING_COMPENSATION_CREATED:
      'Atención, esta acción necesita la validación del supervisor. Se dispone a crear una compensación de ',
    CHART_PROCESS: 'Proceso',
    MESSAGE_LONG: 'Texto largo',
    MESSAGE_COURT: 'Texto corto',
    SITUATION: 'Proceso - Situación',
    SUB_FAMILY: 'Subfamilia',
    CHART_TYPOLOGY: 'Seleccionar uno o más product_codes',
    CHART_BUSINESS_CASE: 'Ejemplo de situación',
    CHART_PRODUCT_CODE: 'Product_code',
    CHOOSE_BUSINESS_CASE: 'Elegir un ejemplo de situación',
    EDIT_REASON: 'Edición del motivo',
    CREATE_REASON: 'Motivo para crear',
    FILTER_BUSINESS_CASE: 'Ejemplo de situación',
    FILTER_DEPARTURE_DATE: 'Fecha viaje desde',
    FILTER_END_DATE: 'Hasta',
    FILTER_SENDING_DATE_FROM: 'Fecha envío desde',
    FILTER_SENDING_DATE_TO: 'Hasta',
    FILTER_CREATION_DATE_FROM: 'Fecha de creación desde',
    FILTER_CREATION_DATE_TO: 'Hasta',
    FILTER_TRANSMITTER: 'Emisor',
    FILTER_STATUS: 'Estado',
    FILTER_STATION_IMPACTED: 'Estación',
    RESET_COMPENSATION: 'Cancelar la compensación',
    FORM_STATIONS: 'Estación',
    EMAIL_INFO: 'NB: Cambiar su propia cuenta resultará en su desconexión automática.',
    FORM_SITUATION: 'Nombre de la situación',
    FORM_TYPOLOGY: 'Nombre del tipo',
    REASON: "Zona 'Motivo'",
    DELAY: "Zona 'Retraso'",
    SUBSTITUTE: "Zona 'Nueva estación & Nuevo horario'",
    DOCK: "Zona 'Andén'",
    COMM_INFO: "Zona 'Informaciones para comunicar'",
    COMM_INFO_LONG: 'Mensaje largo',
    COMM_INFO_SHORT: 'Mensaje corto',
    MORE_INFO: "Zona 'Otras informaciones'",
    COMPENSATION: "Zona 'Compensación & Medidas de asistencia y de SPV'",
    COMPENSATION_ALL: 'Todos los viajeros',
    COMPENSATION_DOWN: 'Viajeros que bajan',
    COMPENSATION_UP: 'Viajeros que suben',
    COMPENSATION_UP_DOWN: 'Viajeros que suben y bajan',
    COMPENSATION_DV_NUMBERS: 'Localizador',
    SIGN: "Zona 'Firma'",
    YES: 'sí',
    NO: 'no',
    ADD_MODIFICATION: 'adición/modificación',
    CONSULTATION: 'consulta',
    UNIQUE: 'solo su usuario',
    ALL: 'todos (sin creación)',
    READ_ONLY: `todos (consulta sola)`,
    NAME: 'Nombre',
    Circulations: 'Circulaciones > Vista',
    Historisation: 'Historial > Vista',
    'Customer-Flux': 'Flujo de viajeros > Vista',
    Reasons: 'Referencial > Motivos',
    'Help-Info': 'Referencial > Ayuda a la información',
    Typologies: 'Referencial > Tipos',
    Situations: 'Referencial > Situación',
    Profiles: 'Acceso > Perfiles',
    Users: 'Acceso > Usurios',
    Communication: 'Funcionalidad: Envío de comunicaciones',
    'Deffered-Communications': 'Funcionalidad: Envío programado',
    PLATFORM: 'Andén',
    SHORT_MESSAGE: "contenido de SMS 'sin procesar'",
    circulationType: 'Tipo de trafico',
    situationsProcess: 'Situación',
  },
  customer: {
    ALL_CUSTOMERS: 'Todos los viajeros del tren',
    DESCENDING_CUSTOMERS: 'Viajeros que bajan en la estación',
    ASCENDING_CUSTOMERS: 'Viajeros que suben en la estación',
  },
  formErrors: {
    REQUIRED_FIELD: 'Campo de texto requerido.',
    STRING_MAX: 'Este campo de texto no puede exceder 100 caracteres.',
    NOT_VALID_EMAIL: 'Email incorrecto.',
    PASSWORD_RULES:
      'Su contraseña debe contener al menos 12 caracteres, incluyendo 1 minúscula, 1 mayúscula, 1 dígito y 1 carácter especial.',
    STRING_MAX_10_CHARACTERS: 'Este campo de texto no puede exceder 10 caracteres.',
    STRING_MAX_20_CHARACTERS: 'Este campo de texto no puede exceder 20 caracteres.',
    PASSWORD_CONFIRM: 'Las dos contraseñas no coinciden.',
    ROLE_EMPTY: 'Se requiere al menos un perfil.',
    INCOMPLETE_ERROR: 'Complete este campo obligatorio',
    INCOMPLETE_DIFFERED_ERROR: 'Complete o cambiar cuando enviar.',
    INVALID_FORMAT: 'Comprobar el formato',
    NAME_RULES: 'Nombre o apellido inválido',
    USERNAME_RULES: 'Nombre de usuario inválido',
    FORBIDDEN_CHARACTERS_ERROR_MESSAGE: 'Presencia de caracteres prohibidos.',
    ELEMENT_LENGTH_ERROR_MESSAGE: 'Formato incorrecto del localizador.',
  },
  menu: {
    MENU_ITEM_1: 'Circulaciones',
    MENU_ITEM_2: 'Flujo de viajeros',
    MENU_ITEM_3: 'Administración',
    MENU_ITEM_4: 'Historial de los mensajes',
    MENU_ITEM_4_1: 'Por OD',
    MENU_ITEM_4_2: 'Por estación',
    MENU_ITEM_3_1: 'Referencials',
    MENU_ITEM_3_2: 'Usuarios',
    MENU_ITEM_3_1_1: 'Ayuda a la información',
    MENU_ITEM_3_1_1_1_1: 'Listado de frases recurrentes',
    MENU_ITEM_3_1_1_1: 'FRASES RECURRENTES',
    MENU_ITEM_3_1_1_2: 'FRASES COMPENSACIÓN',
    MENU_ITEM_3_1_2: 'Motivos',
    MENU_ITEM_3_1_3: 'Situaciones',
    MENU_ITEM_3_1_4: 'TIPOS DE PASAJERO',
    MENU_ITEM_3_1_3_1: 'Situaciones',
    MENU_ITEM_3_1_3_2: 'PLANTILLAS',
    MENU_ITEM_3_1_3_3: 'CONFIGURACIÓN COMUNICACIÓN',
    MENU_ITEM_3_1_4_1: 'Product_codes',
    MENU_ITEM_3_1_4_2: 'TIPOS',
    MENU_ITEM_3_3: 'ACCESO',
    MENU_ITEM_3_3_3: 'PERFILES',
  },
  header: {
    TITLE1: 'Oui',
    TITLE2: 'News',
    passwordExpiryMessage: 'Su contraseña caducará pronto',
    passwordExpiryTooltip: 'Vaya a inicio de sesión > "¿Ha olvidado la contraseña?"',
  },
  Buttons: {
    NEW_USER_CREATION_BUTTON: 'Nuevo usuario',
    NEW_PROFIL_CREATION_BUTTON: 'Nuevo perfil',
    SEARCH_BUTTON: 'Buscar',
    SAVE_BUTTON: 'Registrar',
    CREATE_BUTTON: 'Crear',
    CANCEL_BUTTON: 'Anular',
    RESET_BUTTON: 'Reinicializar',
    CONNECT_BUTTON: 'Conectarse',
    DISCONNECT_BUTTON: 'Desconectar',
    NEXT_BUTTON: 'Siguiente',
    CONTINUE_BUTTON: 'Continuar',
    EDIT_BUTTON: 'Editar',
    COPY_INFO_BUTTON: 'Copiar las informaciones en todas las estaciones siguientes',
    COPY_INFO_BUTTON_LIMITATION: 'Copiar las informaciones en todos los tramos siguientes',
    COPY_DELAY_BUTTON: 'Copiar el retardo en todas las estaciones siguientes',
    SEND_BUTTON: 'Enviar',
    TEMPLATE_BUTTON: 'Previsualización del mensaje',
    PREVIOUS_BUTTON: 'Volver a la etapa anterior',
    ADD_HELP_BUTTON: 'Añadir una frase recurrente',
    ADD_REASON: 'Añadir un motivo',
    ADD_SITUATION: 'Nueva situación',
    ADD_PRODUCT_CODE: 'Añadir un product_code',
    ADD_TYPOLOGY: 'Añadir un tipo',
  },
  filtre: {
    SEARCH_FILTER_TITLE: 'Filtros de búsqueda',
    SEARCH_FILTER_TRAIN_NUMBER: 'Nº del tren',
    SEARCH_FILTER_DEPARTURE_STATION: 'Estación de salida',
    SEARCH_FILTER_ARRIVAL_STATION: 'Estación de llegada',
    SEARCH_FILTER_DEPARTURE_DATE: 'Fecha de inicio',
    SEARCH_FILTER_END_DATE: 'Fecha de fin',
    SEARCH_FILTER_WEEKDAYS: 'Día(s)',
    SEARCH_FILTER_FILTER_BUTTON: 'Filtrar',
    SEARCH_FILTER_RESET_BUTTON: 'Reinicializar',
    SEARCH_FILTER_REFRESH_BUTTON: 'Actualizar',
    SEARCH_FILTER_REFRESH_BUTTON_TOOLTIP: 'hasta "Fecha de circulación del" +10 días',
    SEARCH_FILTER_ONLY_PENDING: 'Si está marcado : solo envíos programados',
    SEARCH_FILTER_NEEDS_DATES: 'Ingrese al menos un rango de fechas.',
    HISTORISATION_TABLE: 'Historial de los mensajes',
    HISTORISATION_PENDING_TABLE: 'Solo envíos programados',
    HISTORISATION_PENDING_LINK: 'Mensajes programados en espera >>',
    REFRESH_LABEL: 'Resultados generados',
    REFRESH_LABEL_DAY: 'el',
    REFRESH_LABEL_TIME: 'a',
    SITUATION: 'Proceso - Situación',
    CONTENT: 'Contenido',
    SUB_FAMILY: 'Subfamilia',
    INCLUDED_CANCEL: 'Cancelaciones incluidas',
    INCLUDED_ROLLING: '+LR',
    INCLUDED_ROLLING_TOOLTIP: 'Si está marcada: incluirá trenes del mismo rodamiento',
    TYPE_CIRCULATION: 'Tipo(s) de trafico',
    HISTO_TYPE_CIRCULATION: 'Tipo de trafico',
  },
  CirculationPage: {
    CIRCULATION_TABLE: 'Cuadro de las circulaciones',
    BULK_COMMUNICATIONS: 'Envío masivo',
    PRE_OP: 'PRE-OP',
    OP: 'OPE',
    BULK_COMMUNICATIONS_ERROR: 'Imposible: todas las circulaciones deben ser del mismo tipo de circulación.',
  },
  UserPage: {
    USER__PAGE_H2: 'Gestión de usuarios',
    USER_RESEARCH_PAGE_H2: 'Buscar un usuario',
    USER_BACK: 'Volver a la lista de usuarios',
    USER_CREATE: 'Crear un usuario',
    USER_UPDATE: 'Modificar un usuario',
  },
  ProductCodesPage: {
    PRODUCT_CODES_REPOSITORY_PAGE_H2: 'Listado de product_codes',
    PRODUCT_CODES_BACK: 'Volver a la lista de product_codes',
    PRODUCT_CODES_CREATE: 'Crear un product_code',
  },
  ProfilPage: {
    PROFIL_RESEARCH_PAGE_H2: 'Gestión de perfiles de acceso',
    PROFIL_BACK: 'Volver a la lista de perfiles',
    PROFIL_CREATE: 'Crear un perfil',
    PROFIL_UPDATE: 'Modificar un perfil',
  },
  ReasonPage: {
    REASON_REPOSITORY_PAGE_H2: 'Listado de motivos',
    REASON_BACK: 'Volver a la lista de los motivos',
    REASON_CREATE: 'Crear un motivo',
    REASON_UPDATE: 'Modificar un motivo',
  },
  ConstitutionPage: {
    CONSTITUTION_REPOSITORY_PAGE_H21: 'Configuración de la comunicación según la situación',
    CONSTITUTION_UPDATE: 'Modificar la configuración de la comunicación',
    CONSTITUTION_BACK: 'Volver a la configuración de la comunicación según la situación',
  },
  SituationPage: {
    SITUATION_REPOSITORY_PAGE_H21: 'Listado de situaciones',
    SITUATION_CREATE1: 'Nueva situación',
    SITUATION_REPOSITORY_PAGE_H2: 'Crear una situación',
    SITUATION_BACK: 'Volver a la lista de situaciones',
    SITUATION_CREATE: 'Crear una situación',
    SITUATION_UPDATE: 'Modificar una situación',
  },
  MaskPage: {
    MASK_REPOSITORY_PAGE_H2: 'Configuración de plantillas según la situación',
    MASK_BACK: 'Volver a la configuración de modelos por situación',
    MASK_UPDATE: 'Modificar plantillas de mensajes',
  },
  TypologyPage: {
    TYPOLOGY_REPOSITORY_PAGE_H21: 'Listado de tipos',
    TYPOLOGY_CREATE1: 'Nueva tipología',
    TYPOLOGY_REPOSITORY_PAGE_H2: 'Listado de tipos',
    TYPOLOGY_BACK: 'Volver a la lista de tipos',
    TYPOLOGY_CREATE: 'Crear un tipo',
    TYPOLOGY_UPDATE: 'Modificar un tipo',
  },
  HelpInfoPage: {
    HELP_INFOS_BACK: 'Volver a la lista de las frases recurrentes',
    HELP_INFO_CREATE: 'Crear una frase recurrente',
    HELP_INFO_UPDATE: 'Modificar una frase recurrente',
    LONG_MSG: 'Texto largo',
    SHORT_MSG: 'Texto corto (opcional)',
    SITUATION_CHOICE: 'Elige (una) situación(es)',
    SUB_FAMILY: 'Subfamilia (opcional)',
    ALLREADY_EXIST: 'La frase tipo ya existe.',
    CIRCULATION_TYPES_CHOICE: 'Elige (un) tipo(s) de tráfico',
  },
  CompensationSentencePage: {
    TITLE: 'Listado de frases automáticas según compensación',
    BACK: 'Volver a la lista de las frases automáticas según la compensación',
    TITLE_UPDATE: 'Modificar una frase automática de compensación',
    NAME: 'Compensación',
    LONG_MSG: 'Texto largo',
  },
  customersStationPage: {
    title: 'Cuadro de los flujos de viajeros : por estación',
    linkOD: '>> por OD',
    linkStation: '>> por estación',
  },
  customersODPage: {
    title: 'Cuadro de los flujos de viajeros : por OD',
  },
  Error404: {
    ERROR404_TITLE: 'Erreur 404 - página no encontrada',
    ERROR404_MESSAGE: 'Ocurrió un error: 404 - Página no encontrada',
    ERROR404_BACK: 'Volver a la página de inicio',
  },
  processus: {
    OP: 'Comunicar en operativo',
    PRE_OP: 'Comunicar en pre-operativo',
    POST_OP: 'Comunicar en post-operativo',
  },
  env: {
    front: 'IHM',
    middleware: 'middleware',
  },
  process: {
    operational: 'Operativo',
    'pre-operational': 'Pre-operativo',
    'post-operational': 'Post-operativo',
  },
  businessCases: {
    'POST-OP-NORMAL': 'Tráfico normal',
    'OP-PLATEFORM': 'Anuncio del andén',
    'PRE-OP-CANCELLATION': 'Cancelación',
    'OP-CANCELLATION': 'Cancelación',
    'OP-OTHER': 'Otras informaciones operativas',
    'PRE-OP-OTHER': 'Otras informaciones pre-operativas',
    'PRE-OP-DIVERSION': 'Desvío',
    'OP-DIVERSION': 'Desvío',
    'OP-STATION_LIMITATION': 'Limitación del trayecto',
    'PRE-OP-STATION_LIMITATION': 'Limitación del trayecto',
    'OP-DELAY': 'Retraso',
    'PRE-OP-DELAY': 'Retraso',
    'POST-OP-DELAY': 'Retraso',
  },
  businessCasesCirculation: {
    'POST-OP-NORMAL': 'Post-operativo - Tráfico normal',
    'OP-PLATEFORM': 'Operativo - Anuncio del andén',
    'PRE-OP-CANCELLATION': 'Pre-operativo - Cancelación',
    'OP-CANCELLATION': 'Operativo - Cancelación',
    'OP-OTHER': 'Operativo - Otras informaciones',
    'PRE-OP-OTHER': 'Pre-operativo - Otras informaciones',
    'PRE-OP-DIVERSION': 'Pre-operativo - Desvío',
    'OP-DIVERSION': 'Operativo - Desvío',
    'OP-STATION_LIMITATION': 'Operativo - Limitación del trayecto',
    'PRE-OP-STATION_LIMITATION': 'Pre-operativo - Limitación del trayecto',
    'OP-DELAY': 'Operativo - Retraso',
    'PRE-OP-DELAY': 'Pre-operativo - Retraso',
    'POST-OP-DELAY': 'Post-operativo - Retraso',
    'PRE-OP-DELAY-ARRIVAL': 'en la llegada',
    'PRE-OP-DELAY-DEPARTURE': 'en la salida',
  },
  sendCommunication: {
    'step-1': 'selección',
    'step-2': 'mensaje',
    serviceSummary: 'Tren %{name} de %{date}',
    CHART_DATE: 'Fecha',
    CHART_TRAIN: 'Tren',
    trains: 'Trens',
    trainsPerDate: 'trens/fecha',
    INFORMATION_HELP_H3: 'Frases estándar',
    modalNoPassengers: {
      desc: 'Ningún pasajero se ve afectado. ¿Deseas continuar?',
    },
    reminderSelections: {
      clientsType: 'Tipo de viajeros',
      clientsTypeValue: {
        all: 'todos',
        ascend: 'suben',
        descend: 'bajan',
        ascendDescend: 'suben y bajan',
      },
      DVNumbersValue: 'Localizador',
      impactedStations: 'Estación(es)',
      excludedStations: 'Excluir estación(es) de subida',
      selectedCarriages: 'Coche(s)',
      selectedCarriagesTypeValue: {
        all: 'todas',
        high: '%{num}-sup.',
        down: '%{num}-inf.',
      },
      Others: 'Otros',
      conflictedTickets: 'solo entradas en conflicto ',
      excludeAllConflictedTickets: 'entradas en conflicto excluidas ',
      selectPurchaseDateTime:
        'comprado %{selectedPurchaseComparison} del %{selectedPurchaseDate} a las %{selectedPurchaseTime}',
    },
    targetStations: {
      noStationsInCommon: 'Algunos tipos de clientes no son compatibles con los trenes seleccionados.',
      odsSummaryLabel: 'Resumen de las OD',
    },
    passengerCount: {
      headText: 'Número de pasajeros afectados:',
      notAvailable: 'Disponible para un máximo de 4 trenes/fechas',
    },
    otherSelection: {
      headText: 'Otras selecciones?',
      typologyText: 'Tipo de pasajero: ',
      conflictedTickets: {
        label: 'En relación con los billetes en conflicto: ',
        onlyLabel: 'Solo en conflicto debido a: ',
        excludeLabel: 'Excluir los billetes en conflicto',
      },
      selectPurchase: {
        label: 'Momento de la reserva:',
        date: 'Fecha:',
        hour: 'Hora:',
        before: 'estrictamente antes',
        after: 'estrictamente después',
        error: 'Complete todos o ninguno de los campos.',
      },
    },
    carriagesSelection: {
      includePassengers: 'incluir pasajeros "sin asiento"',
      includePassengersTooltip: 'Sin asiento asignado (ticket only, bebés excluidos)',
    },
    situationSelection: {
      situationLabel: 'Situación',
      motifLabel: 'Motivo',
      labelOther: 'Otro :',
    },
    communicationChannels: {
      title: 'Elegir los canales de envío',
      mail: 'Mail',
      sms: 'SMS',
      whatsApp: 'WhatsApp',
      flashInfo: 'Flash-info',
    },
    substitutionSchedule: {
      substitutionLabel: 'Nueva estación',
      scheduleLabl: 'Nuevo horario',
      placeholder: '{nombre completo (sin abreviatura)}',
      numberOfChars: '(%{numberOfChars} caractere(s))',
    },
    compensation: {
      savLabel: 'Medidas de asistencia y de servicio postventa',
      compensationLabel: 'Compensación viajeros',
      cancelCompensation: 'Cancelar la compensación',
      confirmCompensationLabel: 'Confirmación de compensación',
      confirmModal: {
        title: 'Ten en cuenta que no habrá ninguna compensación. ¿Quieres seguir enviándolo o cambiarlo?',
        btnCancel: 'No enviar ni modificar.',
        btnConfirm: 'Confirma el envío.',
      },
    },
    placeHolder: {
      modal: {
        title: 'Advertencia: contenido que debe comprobarse en un campo de mensaje.',
        btnCancel: 'Modificar',
        btnConfirm: 'Continuar',
      },
    },
    prohibitedLinks: {
      modal: {
        title: 'Advertencia: contenido que debe comprobarse en un enlace de hipertexto insertado.',
        btnCancel: 'Modificar',
        btnConfirm: 'Continuar',
      },
    },
    backToPreviousStep: 'Volver a la etape anterior',
    signatureTitle: 'Firma',
    msgsPreview: {
      titleAllStations: 'Para todas las estaciones',
      titleImpactedStations: 'Para la estación %{name}',
      textNoTemplates: 'No canal de envío selectionado.',
    },
    differedCommunication: {
      title: 'Cuando enviar',
      immediatLabel: 'inmediato',
      differedLabel: 'programar: ',
      differedNumberDaysLabel: 'días previos a la circulación ',
      differedNumberDaysTooltip:
        'Nota: Solo son posibles los valores compatibles con la(s) fecha(s) de circulación seleccionada(s).',
      differedHourLabel: 'hora de envío',
      differedHourTooltip: 'Nota: Sólo son posibles los horarios compatibles con el número de días introducido.',
      incompatibleTime: 'Envío retrasado incompatible con la(s) fecha(s) de circulación en cuestión.',
      missingAuth: 'No tienes los derechos necesarios.',
      dvNumbersTarget: 'El envío programado no está autorizada con la selección "Localizador".',
    },
  },
  table: {
    COLUMN_COMPENSATION_SENTENCES_NAME: 'Compensación',
    COLUMN_COMPENSATION_SENTENCES_LONG_MSG: 'Texto largo',
    COLUMN_USER_LAST_NAME: 'Apellido',
    COLUMN_USER_FIRST_NAME: 'Nombre',
    COLUMN_USER_EMAIL: 'Correo electrónico',
    COLUMN_USER_PROFILE: 'Perfil',
    COLUMN_CIRCULATION: 'Circulaciones',
    COLUMN_VUE: 'Vista',
    COLUMN_HISTOTISATION: 'Historial',
    COLUMN_FLUX_CLIENT: 'Flujo de viajeros',
    COLUMN_FONCTIONNALITES: 'Funcionalidad',
    COLUMN_ENVOI_COMM: 'Envío de comunicaciones',
    COLUMN_ENVOI_DIFF: 'Envío programado',
    COLUMN_REF: 'Administración > Referencial',
    COLUMN_MOTIFS: 'Motivos',
    COLUMN_AIDES_INFO: 'Ayuda a la información',
    COLUMN_TYPO: 'Tipos',
    COLUMN_SITUATION: 'Situación',
    COLUMN_ADMIN: 'Administración > Acceso',
    COLUMN_PROFIL: 'Perfiles',
    COLUMN_USERS: 'Usurios',
    COLUMN_USER_CIRCULATION: 'Tipo de trafico',
    COLUMN_USER_GROUP: 'Etiqueta',
    COLUMN_EDIT: 'Modificar',
    COLUMN_EDIT_DELETE: 'Modificar / Suprimir',
    COLUMN_DELAY: 'Retraso',
    COLUMN_INFO: 'Informaciones para comunicar',
    COLUMN_INFO_COMP: 'Otras informaciones',
    COLUMN_COMP: 'Compensación & Medidas de asistencia y de SPV',
    COLUMN_QUAI: 'Andén',
    COLUMN_ALL: 'Todos',
    COLUMN_UP: 'Suben',
    COLUMN_DOWN: 'Bajan',
    COLUMN_UP_DOWN: 'Suben y bajan',
    COLUMN_DV_NUMBERS: 'Localizador',
    COLUMN_LONG: 'Largo',
    COLUMN_COURT: 'Corto',
    COLUMN_SUBSTITUTION: 'Nueva estación & Nuevo horario',
    COLUMN_DELETE: 'Suprimir',
    CHART_PROCESS: 'Proceso',
    CHART_PROCESS_SITUATION: 'Proceso - Situación',
    CHART_PASSENGERS: 'Pasajeros',
    CHART_MAIL_CHANNEL: 'Canal correo electrónico',
    CHART_CHANNEL_CHECKED: 'Canal marcado por defecto',
    CHART_DEFAULT_OBJECT: 'Asunto por defecto',
    CHART_DEFAULT_HEADBAND: 'Cabecera por defecto',
    CHART_DEFAULT_CHECKED: 'Marcado por defecto',
    CHART_MASK: 'Plantilla',
    CHART_SMS_CHANNEL: 'Canal SMS',
    CHART_WHATSAPP_CHANNEL: 'Canal WhatsApp',
    CHART_MASK_REFERENCES: 'Plantilla de referencia y parámetros',
    CHART_MASK_PREVIEW: 'Plantilla de vista previa',
    CHART_FLASH_INFO: 'FlashInfo',
    CHART_TYPOLOGY: 'Tipo',
    CHART_LINKED_PRODUCT_CODE: 'Product_code relacionado',
    CHART_BUSINESS_CASE: 'Ejemplo de situación',
    CHART_PRODUCT_CODE: 'Product_code',
    CHART_REASON: 'Motivo',
    CHART_SITUATION: 'Situación',
    CHART_DATE: 'Fecha',
    CHART_TRAIN: 'Tren',
    CHART_TRAIN_STOP_DURATION: 'Tiempo de parada',
    CHART_ARRIVAL_SCHEDULE: 'Hora de llegada',
    CHART_DEPARTURE_SCHEDULE: 'Hora de salida',
    CHART_PASSENGER_NUMBER: 'Número de pasajeros',
    CHART_PASSENGER_NUMBER_UP: 'Número de pasajeros',
    CHART_PASSENGER_NUMBER_DOWN: 'Número de pasajeros',
    CHART_DESCENDING_PASSENGERS: 'Bajadas',
    CHART_DESCENDING_PASSENGERS_1: '1 a 8',
    CHART_DESCENDING_PASSENGERS_2: '9 a 16',
    CHART_ASCENDING_PASSENGERS: 'Subidas',
    CHART_ASCENDING_PASSENGERS_1: '1 a 8',
    CHART_ASCENDING_PASSENGERS_2: '9 a 16',
    CHART_TOTAL: 'Total',
    CHART_CHILDREN: 'Niños',
    CHART_PWD: 'Solo silla de ruedas',
    HART_PWD0: '(Silla de ruedas incluida)',
    HART_PWD1: 'Prestaciones de asistencia',
    HART_PWD2: 'Subidas',
    HART_PWD3: 'Bajadas',
    CHART_BAMB: 'Bebés',
    CHART_STATION: 'Estación',
    CHART_SUM: 'Totales',
    CHART_SUM_1: '1 a 8',
    CHART_SUM_2: '9 a 16',
    CHART_SUM_3: '1 a 16',
    CHART_SUM_3_TOOLTIP: 'Incluido ‘sin asiento’ ',
    CHART_TYPOLOGY_PASSENGERS: 'Tipo de pasajero',
    CHART_DATE_TIME_SENDING: 'Fecha y hora de envío',
    CHART_CREATION_DATE: 'Fecha y hora de creación',
    CHART_TRANSMITTER: 'Emisor',
    CHART_TRAIN_DATE: 'Fecha del tren',
    CHART_DEPARTURE: 'Salida',
    CHART_ARRIVAL: 'Llegada',
    CHART_STATIONS: 'Estación',
    CHART_TIME: 'Hora',
    CHART_SEND_STATUS: 'Estado de envío',
    CHART_EMAIL: 'E-mail ',
    CHART_WHATSAPP: 'WhatsApp',
    CHART_LAST_SEND_DETAILS: 'Detalles',
    CHART_CUSTOMERS: 'Viajeros',
    CHART_SELECTED_STATION: 'Estación',
    CHART_TARGETING: 'Selección',
    CHART_EXCLUSION: 'Exclusión de subida',
    CHART_CARRIAGE: 'Coche',
    CHART_OTHER: 'Otros',
    CHART_CHANNEL: 'Canales de envío',
    CHART_DELAY: 'Tiempo de retraso',
    CHART_UP: '-sup',
    CHART_DOWN: '-inf',
    CHART_YES: 'Sí',
    CHART_NO: 'No',
    CHART_COMPENSATION: 'Compensación',
    CHART_AMOUNT_COMPENSATION: 'Nivel de compensación',
    CHART_YES_COMPENSATION: 'sí',
    CHART_NO_COMPENSATION: 'no',
    CHART_PROGRAMMATION_ELEMENTS: 'Elementos de programación',
    CHART_DAYS_BEFORE_CIRCULATION: 'Número de días con circulación',
    CHART_SENT_TIME: 'Tiempo de envío',
  },
  Modal: {
    USER_MODAL_TITLE: 'Confirmación antes de supresión',
    USER_DELETE_CONFIRM: ' ¿Quieres suprimir el usuario? ',
    PROFIL_DELETE_CONFIRM: '¿Quieres suprimir el profile siguiente?',
    CONFIRM_YES: 'Sí',
    CONFIRM_NO: 'No',
    HELPINFO_MODAL_TITLE: 'Confirmación antes de supresión',
    HELPINFO_DELETE_CONFIRM: '¿Quieres suprimir el frase tipo?',
    REASON_MODAL_TITLE: 'Confirmación antes de supresión',
    REASON_DELETE_CONFIRM: '¿Quieres suprimir el motivo siguiente? ',
    PRODUCT_CODE_DELETE_CONFIRM: '¿Quieres suprimir el product_code siguiente? ',
    PRODUCT_CODE_MODAL_TITLE: 'Confirmación antes de supresión',
    TYPOLOGY_DELETE_CONFIRM: '¿Quieres suprimir la tipología siguiente? ',
    HISTORIC_PENDING_MESSAGE_CONFIRM:
      'Atención, ¿confirma la cancelación del envío programado para estos trens/fecha ? :',
    ERROR: 'Ten en cuenta que no habrá ninguna compensación. ¿Quieres seguir enviándolo o cambiarlo?',
    BTN1: 'No enviar ni modificar.',
    SITUATION_DELETE_CONFIRM: '¿Quieres suprimir la situación siguiente? ',
    BTN2: 'Confirma el envío.',
    WARNING_SITUATION: 'Tenga en cuenta que esto eliminará todas las configuraciones asociadas con esta situación.',
    DELETE_MODAL: {
      OK: 'ok',
      message: 'La acción fracasó. Inténtalo de nuevo.',
    },
    CONTINUE: 'Continuar',
    TRAIN_WARNING: 'Atención, está a punto de enviar una comunicación en el tren %{serviceName} del ',
    TRAIN_WARNING_DATE: '%{serviceDay} %{serviceDate}.',
  },
  notif: {
    NOTIF_SENDING_OK_TITTLE: 'Confirmación de envío',
    NOTIF_SENDING_OK_TEXT: 'La comunicación fue enviada con successo.',
    NOTIF_SENDING_KO_TITTLE: 'Envío fallado',
    NOTIF_SENDING_KO_TEXT: 'El envío de la comunicación ha fallado.',
    NOTIF_DECONNEXION: 'Ha sido desconectado después de cambiar su cuenta',
  },
  popin: {
    SELECTED_COACHES: 'Coches seleccionados',
    POPIN_DETAILS_CREATION_DATE_TIME: 'Fecha y hora de creación',
    POPIN_DETAILS_SEND_DATE_TIME: 'Fecha y hora de envío',
    POPIN_DETAILS_SCHEDULED_DATE_TIME: 'Fecha y hora de envío programado',
    POPIN_DETAILS_PLATFORM: 'Andén',
    POPIN_DETAILS_REASON: 'Motivo',
    POPIN_DETAILS_INCIDENT: 'Detalles sobre el incidente',
    POPIN_DETAILS_COMPENSATION: 'Compensación',
    POPIN_DETAILS_SAV: 'Medidas de asistencia y de SPV',
    POPIN_DETAILS_SUBSTITUTION_STATION: 'Nueva estación',
    POPIN_DETAILS_NEW_SCHEDULE: 'Nuevo horario',
    POPIN_DETAILS_ASCENDING_STATIONS_EXCLUSION: 'Excluir estaciones de subida',
    POPIN_DETAILS_ODS_SUMMARY_LABEL: 'Resumen de las OD:',
    POPIN_SITUATION: 'Situación',
    POPIN_DETAILS_DELAY: 'Retraso',
    POPIN_CLOSED_BAR: 'Bar cerrado',
    POPIN_DETAILS_INFORMATION_COM: 'Informaciones para comunicar (largo)',
    POPIN_DETAILS_INFORMATION_COM_SHORT: 'Informaciones para comunicar (corto)',
    POPIN_DETAILS_OTHER_INFORMATION_COM: 'Otras informaciones (largo)',
    POPIN_DETAILS_OTHER_INFORMATION_COM_SHORT: 'Otras informaciones (corto)',
    POPIN_SERVICE_NUMBER: 'Tren n°',
    POPIN_DETAILS_SIGNATURE: 'Firma',
    POPIN_TRANSMITTER: 'Emisor',
    POPIN_CHANNEL: 'Canales de envío',
    POPIN_MAIL_OBJECT: 'Asunto del correo',
    POPIN_HEADER_TITLE: 'Cabecera del correo',
    POPIN_CLIENTS_TYPE: 'Tipo de viajeros',
    POPIN_DV_NUMBERS: 'Localizador',
    POPIN_IMPACTED_STATIONS: 'Estación',
    POPIN_EXCLUDED_STATIONS: 'Excluir estación(es) de subida',
    POPIN_OTHERS: 'Otros',
    POPIN_UPSTAGE: '-sup',
    POPIN_DOWNSTAGE: '-inf',
    POPIN_PASSENGERS_WITHOUT_SEATS: ' / Sin ubicación: ',
    CONCERNED_PASSENGERS: 'Número de pasajeros afectados :',
  },
  confirmation: {
    TEXT_CONF_PAGE_OK_1: 'La comunicación fue enviada con succeso.',
    TEXT_CONF_PAGE_OK_2: 'Por favor, cierra la pestaña.',
    TEXT_CONF_PAGE_KO_1: 'Envío fallido. Inténtalo de nuevo.',
    TEXT_CONF_PAGE_KO_STEP_1: 'Campos obligatorios en el paso 1',
    TEXT_CONF_PAGE_KO_DEFFERED:
      'El envío no es posible. Por favor, modifique los parámetros de envío diferido solicitados.',
    CLOSE_BUTTON: 'Cierra la pestaña',
  },
  roles: {
    IVAdmin: 'Administrador',
    IVAgent: 'Supervisor IV',
  },
  keywords: {
    tooltip: "escriba '{' para agregar variables",
  },
  weekdaysInput: {
    mon: 'LU',
    tue: 'MA',
    wed: 'MI',
    thu: 'JU',
    fri: 'VI',
    sat: 'SA',
    sun: 'DO',
  },
  defaultError: 'Se ha producido un error. Inténtalo de nuevo.',
};

export default locale;
